import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrency } from "../../redux/actions/getcurrencyAction";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

import {
	fetchWorkLevelTypeData,
	selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
	fetchWorkLocationTypeData,
	selectLocationType,
	selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
	fetchDesignation,
	selectDesignation,
} from "../../redux/actions/designationAction";
import {
	fetchSalaryType,
	selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import { fetchAllCompany } from "../../redux/actions/getAllCompanyAction";

const EditJobs = () => {
	const { JobId } = useParams();
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const sessionId = localStorage.getItem("sessionId");
	const companyType = localStorage.getItem("userType");
	const companyUId = localStorage.getItem("userUID");

	const [display, setDisplay] = useState(false);
	const [minimumSalary, setMinimumSalary] = useState("");
	const [maximumSalary, setMaximumSalary] = useState("");
	const [currency, setCurrency] = useState("");
	const [jobTitle, setJobTitle] = useState("");
	const [requirement, setRequirement] = useState(null);
	const [jobDescription, setjobDescription] = useState("");
	const [cityId, setCityId] = useState(null);
	const [jobData, setJobData] = useState([]);
	const [associatejobData, setassociateJobData] = useState([]);
	const [workLocationSearch, setworkLocationSearch] = useState("");
	const [workLevelId, setworkLevelId] = useState("");
	const [designationSearch, setDesignationSearch] = useState("");
	const [salaryTypeSearch, setSalaryTypeSearch] = useState("");
	const [jobTypeSearch, setjobTypeSearch] = useState("");


	const getJobDetail = () => {
		axios
			.get(`/Job/GetJobDetails?JobId=${JobId}`)
			.then((response) => {
				const res = response.data.responseData;
				const associatedcom = response.data.responseData.associateCompanyShortInfo;
				setJobData(res);
				setassociateJobData(associatedcom);
				setJobTitle(res?.title);
				setCurrency(res.currency);
				setMinimumSalary(res?.minSalary);
				setMaximumSalary(res?.maxSalary);
				setSalaryTypeSearch(res?.salaryTypeId);
				setDesignationSearch(res?.designationName);
				setworkLocationSearch(res?.workLocationTypeId);
				setworkLevelId(res?.workLevelType);
				setjobTypeSearch(res?.jbTypId);
				setCityId(res?.cityId);
				dispatch(fetchCityData(res?.cityName));
				setRequirement(res?.requirement);
				setjobDescription(res?.description);
				setCompanyListId(associatedcom?.compId);
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					console.log(error);
				} else {
					console.log(error);
				}
			});
	};

	useEffect(() => {
		getJobDetail();
	}, []);

	// .......................... Edit-Candid Disabled and Enabaled
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);


	const stripHtmlTags = (html) => {
		const doc = new DOMParser().parseFromString(html, "text/html");
		return doc.body.textContent || "";
	};

	const handleFieldChange = (setter, value, fieldName) => {
		// ReactQuill ka data properly clean karein
		const cleanedValue = fieldName === "jobDescription" || fieldName === "requirement"
			? stripHtmlTags(value)
			: value;

		setter(value); // State update karein original value ke saath

		// Convert non-string values to empty strings
		const updatedJobTitle = fieldName === "jobTitle" ? cleanedValue : jobTitle || "";
		const updatedMinimumSalary = fieldName === "minimumSalary" ? cleanedValue : minimumSalary || "";
		const updatedMaximumSalary = fieldName === "maximumSalary" ? cleanedValue : maximumSalary || "";
		const updatedCurrency = fieldName === "currency" ? cleanedValue : currency || "";
		const updatedSalaryTypeSearch = fieldName === "salaryTypeSearch" ? cleanedValue : salaryTypeSearch || "";
		const updatedDesignationSearch = fieldName === "designationSearch" ? cleanedValue : designationSearch || "";
		const updatedWorkLevelSearch = fieldName === "workLevelSearch" ? cleanedValue : workLevelId || "";
		const updatedWorkLocationSearch = fieldName === "workLocationSearch" ? cleanedValue : workLocationSearch || "";
		const updatedJobTypeSearch = fieldName === "jobTypeSearch" ? cleanedValue : jobTypeSearch || "";
		const updatedCityListSearch = fieldName === "cityListSearch" ? cleanedValue : cityId || "";
		const updatedRequirement = fieldName === "requirement" ? cleanedValue : requirement || "";
		const updatedJobDescription = fieldName === "jobDescription" ? cleanedValue : jobDescription || "";

		// Validate all required fields
		const isValid =
			updatedJobTitle.trim() !== "" &&
			updatedMinimumSalary !== "" &&
			updatedMaximumSalary !== "" &&
			Number(updatedMaximumSalary) >= Number(updatedMinimumSalary) && // Ensure max salary is greater than min salary
			updatedCurrency.trim() !== "" &&
			updatedSalaryTypeSearch?.toString().trim() !== "" &&
			updatedDesignationSearch?.toString().trim() !== "" &&
			updatedWorkLevelSearch?.toString().trim() !== "" &&
			updatedWorkLocationSearch?.toString().trim() !== "" &&
			updatedJobTypeSearch?.toString().trim() !== "" &&
			updatedCityListSearch?.toString().trim() !== "" &&
			updatedRequirement.trim() !== "" &&
			updatedJobDescription.trim() !== "";

		setFormChanged(isValid);
	};

	// ..............................  Edit-Candid Disabled and Enabaled

	const handleSubmit = async () => {
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission
		const body = {
			sessionId: sessionId,
			compType: companyType,
			compUid: companyUId,
			cityId: cityId,
			jbTypId: jobTypeSearch,
			workLevelType: workLevelId,
			workLocationType: workLocationSearch,
			DesignationName: designationSearch,
			salaryTypeId: salaryTypeSearch,
			minSalary: minimumSalary,
			maxSalary: maximumSalary,
			currency: currency,
			title: jobTitle,
			description: jobDescription,
			requirement: requirement,
			jobId: JobId,
		};
		console.log("edit job data", body);
		if (
			cityId === "" ||
			jobTypeSearch === "" ||
			workLevelId === "" ||
			workLocationSearch === "" ||
			designationSearch === "" ||
			salaryTypeSearch === "" ||
			minimumSalary === "" ||
			maximumSalary === "" ||
			requirement === null ||
			currency === "" ||
			jobTitle === "" ||
			jobDescription === ""
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
		} else {
			try {
				const res = await axios.post("/Job/EditJob", body);
				console.log("gashgdjdgsa", res);
				toast.success(res.data.message);
				navigate("/job/My-Jobs");
				setFormChanged(false); // Disable the button after successful update
			} catch (e) {
				if (e.response && e.response.status === 404) {
					toast.error(e.response.data.errors.model);
					console.log("error", e);
					
				} else {
					toast.error(e.response.data.errors.model);
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};


	// ...............................Work Level Dropdown.......................................

	const { workLevelList, selectedworkLevelId } = useSelector(
		(state) => state.workLevelType
	);

	useEffect(() => {
		dispatch(fetchWorkLevelTypeData());
	}, [dispatch]);

	const handleWorkLevel = (selectedOption) => {
		if (selectedOption) {
			setworkLevelId(selectedOption.value);
		}
	};

	// ...............................Work Level Dropdown.......................................

	const { workLocation, selectedCategoryId } = useSelector(
		(state) => state.workLocationType
	);

	useEffect(() => {
		dispatch(fetchWorkLocationTypeData());
	}, [dispatch]);

	const handleWorkLoc = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			setworkLocationSearch(selectedOption.value);
		}
	};

	// ...............................Designation Dropdown.......................................

	const { designationList, selectedDesignationId } = useSelector(
		(state) => state.designation
	);

	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	const handleDesignation = (selectedOption) => {
		if (selectedOption) {
			setDesignationSearch(selectedOption.value);
		}
	};
	// ...............................Designation Dropdown.......................................

	// ...............................Salary Dropdown.......................................

	const { salaryTypeList, selectedSalaryTypeId } = useSelector(
		(state) => state.salaryType
	);

	useEffect(() => {
		dispatch(fetchSalaryType());
	}, [dispatch]);

	const handleSalaryType = (selectedOption) => {
		if (selectedOption) {
			setSalaryTypeSearch(selectedOption.value);
		}
	};
	// ...............................Salary Dropdown.......................................

	// ...............................Job Type Dropdown.......................................
	const { jobTypeList, selectedJobTypeId } = useSelector(
		(state) => state.jobType
	);

	useEffect(() => {
		dispatch(fetchJobType());
	}, [dispatch]);

	const handleJobType = (selectedOption) => {
		if (selectedOption) {
			setjobTypeSearch(selectedOption.value);
		}
	};
	// ...............................Job Type Dropdown.......................................

	// ...............................City Dropdown.......................................
	const { cityList, selectedcityId } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData());
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setCityId(selectedOption.value);
		}
	};

	// ...............................City Dropdown.......................................

	// ...............................currency Dropdown.......................................

	const { currencyList, selectedcurrencyId } = useSelector(
		(state) => state.currency
	);
	useEffect(() => {
		dispatch(fetchCurrency());
	}, [dispatch]);

	const handleCurrency = (selectedOption) => {
		if (selectedOption) {
			setCurrency(selectedOption.label);
		}
	};

	// ...............................Company Category DDL.......................................
	const [companyListId, setCompanyListId] = useState("");
	const { getAllcompaniesList, selectedcompaniesId } = useSelector(
		(state) => state.getAllCompany
	);

	useEffect(() => {
		dispatch(fetchAllCompany());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			setCompanyListId(selectedOption.value);
		}
	};
	// ...............................Company Category DDL.......................................

	return (
		<>
			<div className="main-container postJob">
				<div className="content-wrapper">
					<div className="title delete-title  edit-delete-title ">
						<h1 style={{ fontWeight: "bold" }}>
							<span className="orange-box"></span> Edit Job
						</h1>
					</div>

					<div className="card Alertcard PostCard pt-3">
						{companyType === 'Recruiter' ?
							<>
								<div className=" col-md-12 post-job-details-form p-0 pt-3">
									<div controlId="post-form-row my-0  ">
										<div className="mb-2 main-company-disabled">
											<div className="post-form-group mb-0 placeholder-from-react-select-Edit Company-React-category">
												<label htmlFor="about">
													Company 
												</label>
												<ReactSelect
													options={getAllcompaniesList}
													onChange={handleSelectCompany}
													// onChange={(option) => handleFieldChange(setCompanyListId, option ? option.value : "")} // Track changes
													value={
														getAllcompaniesList.find(
															(option) => option.value === companyListId
														) || null
													}
													placeholder="Select company"
													classNamePrefix="react-select"
													className="form-control"
													styles={customStyles}
													isDisabled
													isClearable
												/>
											</div>
										</div>
									</div>
								</div>
							</> :
							''}


						<div className="post-job-details-form p-0">
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Job Title <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="text"
										value={jobTitle}
										// onChange={(e) => setJobTitle(e.target.value)}
										// onChange={(e) => handleFieldChange(setJobTitle, (e.target.value))}
										onChange={(e) => handleFieldChange(setJobTitle, e.target.value, "jobTitle")}
										onPaste={(e) => handleFieldChange(setJobTitle, e.clipboardData.getData("text"), "jobTitle")}
									/>
									{display && !jobTitle ? (
										<span className="error_msg_lbl">Enter Job Title</span>
									) : null}
								</div>

								<div className="  post-form-group placeholder-from-react-select-Edit currency-input-from">
									<label htmlFor="about">
										Currency <span className="text-danger">*</span>
									</label>
									<ReactSelect
										// options={currencyList}
										options={currencyList.map(option => ({
											...option,
											label: option.label.toUpperCase() // Convert label to uppercase
										}))}
										// onChange={handleCurrency}
										onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "", "currency")}
										// onChange={(option) => handleFieldChange(setCurrency, option ? option.label : "")} // Track changes
										// value={
										// 	currencyList.find(
										// 		(option) => option.label === currency
										// 	) || null
										// }
										value={
											currencyList
												.map(option => ({ ...option, label: option.label.toUpperCase() })) // Ensure matching uppercase options
												.find(option => option.label === currency) || null
										}
										placeholder="Select Currency"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									// onInputChange={(inputValue) => setSalaryTypeSearch(inputValue)}
									// invalid={display && salaryTypeSearch === ""}
									/>

									{display && !currency ? (
										<span className="error_msg_lbl">Select Currency </span>
									) : null}
								</div>

							</div>
						</div>

						<div className="post-job-details-form p-0">
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Minimum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="text"
										value={minimumSalary}
										placeholder="Enter Minimum Salary"
										// onChange={(e) => setMinimumSalary(e.target.value)}
										// onChange={(e) => handleFieldChange(setMinimumSalary, (e.target.value))}
										onChange={(e) => handleFieldChange(setMinimumSalary, e.target.value, "minimumSalary")}
										onPaste={(e) => handleFieldChange(setMinimumSalary, e.clipboardData.getData("text"), "minimumSalary")}
									/>
									{display && !minimumSalary ? (
										<span className="error_msg_lbl">Enter Minimum Salary</span>
									) : null}
								</div>

								<div className="post-form-group">
									<label htmlFor="about">
										Maximum Salary <span style={{ color: "red" }}>*</span>
									</label>
									<input
										type="text"
										value={maximumSalary}
										placeholder="Enter Maximum Salary"
										// onChange={(e) => setMaximumSalary(e.target.value)}
										// onChange={(e) => handleFieldChange(setMaximumSalary, (e.target.value))}
										onChange={(e) => handleFieldChange(setMaximumSalary, e.target.value, "maximumSalary")}
										onPaste={(e) => handleFieldChange(setMaximumSalary, e.clipboardData.getData("text"), "maximumSalary")}
									/>
									{display && !maximumSalary ? (
										<span className="error_msg_lbl">Enter Maximum Salary</span>
									) : null}
								</div>
							</div>

							{/* ....................... 3 Row ......................... */}
							{/* ........Salary Type........ */}

							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Salary Type <span className="text-danger"> *</span>
									</label>
									<ReactSelect
										options={salaryTypeList}
										// onChange={handleSalaryType}
										// onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setSalaryTypeSearch, option ? option.value : "", "salaryTypeSearch")}
										value={
											salaryTypeList.find(
												(option) => option.value === salaryTypeSearch
											) || null
										}
										placeholder="Select Salary Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>

									{display && !salaryTypeSearch ? (
										<span className="error_msg_lbl">Select Salary Type </span>
									) : null}
								</div>
								{/* ........Designation........ */}

								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Designation<span className="text-danger ms-2">*</span>
									</label>

									<ReactSelect
										options={designationList}
										// onChange={handleDesignation}
										// onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "")} // Track changes
										onChange={(option) => handleFieldChange(setDesignationSearch, option ? option.label : "", "designationSearch")}
										value={
											designationList.find(
												(option) => option.label === designationSearch
											) || null
										}
										placeholder="Select Designation"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										invalid={display && designationSearch === ""}
										isClearable
									/>
									{display && !designationSearch ? (
										<span className="error_msg_lbl">Select Designation </span>
									) : null}
								</div>
							</div>

							{/* ....................... 4 Row ........................ */}
							{/* ........Work level type........ */}
							<div className="post-form-row my-0">
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Work Level Type<span className="text-danger ms-2">*</span>
									</label>
									<ReactSelect
										options={workLevelList}
										// onChange={handleWorkLevel}
										// onChange={(option) => handleFieldChange(setworkLevelId, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLevelId, option ? option.value : "", "workLevelSearch")}
										value={
											workLevelList.find(
												(option) => option.value === workLevelId
											) || null
										}
										placeholder="Select Work Level Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										invalid={display && workLevelId === ""}
										isClearable
									/>
									{display && !workLevelId ? (
										<span className="error_msg_lbl">
											Select Work Level Type{" "}
										</span>
									) : null}
								</div>

								{/* ........Work location type........ */}

								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Work Location Type<span className="text-danger ms-2">*</span>
									</label>

									<ReactSelect
										options={workLocation}
										// onChange={handleWorkLoc}
										// onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setworkLocationSearch, option ? option.value : "", "workLocationSearch")}
										value={
											workLocation.find(
												(option) => option.value === workLocationSearch
											) || null
										}
										placeholder="Select Work Location Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
									{display && !workLocationSearch ? (
										<span className="error_msg_lbl">
											Select Work Location Type{" "}
										</span>
									) : null}
								</div>
							</div>

							{/* ....................... 5 Row ........................ */}
							<div className="post-form-row my-0">
								{/* ........ Job type........ */}
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										Job Type<span className="text-danger ms-2">*</span>
									</label>
									<ReactSelect
										options={jobTypeList}
										// onChange={handleJobType}
										// onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setjobTypeSearch, option ? option.value : "", "jobTypeSearch")}
										value={
											jobTypeList.find(
												(option) => option.value === jobTypeSearch
											) || null
										}
										placeholder="Select Job Type"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable
									/>
									{display && !jobTypeSearch ? (
										<span className="error_msg_lbl">Select Job Type </span>
									) : null}
								</div>

								{/* ........ City ........ */}
								<div className="post-form-group placeholder-from-react-select-Edit">
									<label htmlFor="about">
										City <span className="text-danger">*</span>
									</label>

									<ReactSelect
										options={cityList}
										// onChange={handleCitySelect}
										// onChange={(option) => handleFieldChange(setCityId, option ? option.value : "")} // Track changes
										onChange={(option) => handleFieldChange(setCityId, option ? option.value : "", "cityListSearch")}
										value={
											cityList.find(
												(option) => option.value === cityId
											) || null
										}
										placeholder="Search & Select City"
										onInputChange={handleCityInputChange}
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control"
										isClearable

										invalid={display && cityId === ""}
									/>
									{display && !cityId ? (
										<span className="error_msg_lbl">Search & Select City </span>
									) : null}
								</div>
							</div>
						</div>

						<div className="post-job-form">
							<div className="post-form-group placeholder-from-react-select-Edit placeholder-from-react-select">
								<label htmlFor="job-requirement" className="post-form-label mt-0">
									Requirement <span>*</span>
								</label>
								{/* <textarea
									id="job-requirement"
									className="post-description-input"
									placeholder="Type The Job Requirement Here..."
									value={requirement}
									// onChange={(e) => setRequirement(e.target.value)}
									onChange={(e) => handleFieldChange(setRequirement, e.target.value)}
								></textarea> */}
								<ReactQuill
									id="job-requirement"
									className="post-description-input"
									placeholder="Type The Job Requirement Here..."
									value={requirement}
									// onChange={(e) => setRequirement(e.target.value)}
									// onChange={(value) => handleFieldChange(setRequirement, value)}
									onChange={(value) => handleFieldChange(setRequirement, value, "requirement")}


								/>
								{display && !requirement ? (
									<span className="error_msg_lbl">Enter Requirement</span>
								) : null}
							</div>
						</div>

						<div className="post-job-description py-0 placeholder-from-react-select">
							<label htmlFor="job-description" className="post-form-label mt-0">
								Job Description  <span> *</span>
							</label>
							<ReactQuill
								id="job-description"
								className="post-description-input"
								placeholder="Type The Job Description Here..."
								value={jobDescription}
								// onChange={(e) => setjobDescription(e.target.value)}
								// onChange={(value) => handleFieldChange(setjobDescription, value)}
								onChange={(value) => handleFieldChange(setjobDescription, value, "jobDescription")}

							/>
							{display && !jobDescription ? (
								<span className="error_msg_lbl">Enter Job Description</span>
							) : null}
						</div>

						<Button
							// className="mainBtn apply-job mb-3 mt-2"
							onClick={handleSubmit}
							className={`btn btn-primary mainBtn apply-job mb-3 mt-2 ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
							// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
							disabled={!formChanged || isSubmitting}
							style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
						>

							Submit
						</Button>
					</div>
				</div>
			</div>
		</>
	);
};

export default EditJobs;
